/*!
 * Kallov Hair. The Prism.
 * Copyright (c) 2026 Kallov Hair. All rights reserved.
 */
/* Kallov: words never spill out of their box on the vault page (Alexis, 26 Sep: "the content
   of the box should always fit in the box"). A long Vault Key, three or more colors, or a long
   name made the key run out of the key plate and the readout under the stopper. The key and
   the readout's value now shrink until their longest piece fits the box's width and the whole
   takes at most two lines; lines only break between whole parts of the key (after a hyphen),
   and if a box is ever narrower than that, the words wrap inside it rather than run out.
   Every other box on the vault page (the stage panels, the formula card, her combination
   card) wraps a long word inside itself instead of letting it cross the border. */
(function () {
  var css = '.kallov-prism .kp-keyplate,.kallov-prism .kp-lookRead,.kallov-prism .kp-fcard,.kallov-prism .kp-st,.kallov-prism .kp-card,.kallov-prism .kp-vcard{overflow-wrap:anywhere;min-width:0}'
    + '.kallov-prism .kp-lookRead{max-width:100%}'
    + '.kallov-prism .kp-keyplate .kp-code,.kallov-prism .kp-lookRead b{max-width:100%;overflow:hidden}';
  function style() {
    if (document.getElementById('kp-fitbox-css')) return;
    var s = document.createElement('style'); s.id = 'kp-fitbox-css'; s.textContent = css; document.head.appendChild(s);
  }
  /* shrink one element until its longest unbreakable piece fits and it takes at most two lines */
  function fit(el, min) {
    if (!el || !el.textContent || !el.clientWidth) return;
    el.style.fontSize = '';
    el.style.letterSpacing = '';
    var cs = getComputedStyle(el), s = parseFloat(cs.fontSize) || 20;
    var ls = parseFloat(cs.letterSpacing), lsr = isNaN(ls) ? 0 : ls / s;
    var lh = parseFloat(cs.lineHeight), lhr = isNaN(lh) ? 1.2 : lh / s;
    el.style.overflowWrap = 'normal'; el.style.wordBreak = 'normal';
    var n = 0;
    while (n++ < 80 && s > min && (el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > s * lhr * 2.2 + 2)) {
      s -= 1;
      el.style.fontSize = s + 'px';
      if (lsr) el.style.letterSpacing = (s * lsr).toFixed(2) + 'px';
    }
    el.style.overflowWrap = ''; el.style.wordBreak = '';
  }
  function all() {
    fit(document.getElementById('keyCode'), 14);
    var rd = document.querySelector('#read b');
    fit(rd, 14);
  }
  function start() {
    style();
    var raf = 0, go = function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; all(); }); };
    var watch = function (el) { if (el) new MutationObserver(go).observe(el, { childList: true, characterData: true, subtree: true }); };
    watch(document.getElementById('keyCode'));
    watch(document.getElementById('read'));
    var kp = document.getElementById('keyplate');
    if (kp) new MutationObserver(go).observe(kp, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', go);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go);
    go();
  }
  if (!document.querySelector('.kallov-prism')) return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
